<template lang="pug">
	.input-select-dropdown(v-show="showed" :style="position" :class="{'direction-up': dropup}" v-pseudo-modal-name="'input-select-dropdown'")
		MultiLevelDropdownMenu(ref="dropdownMenu" @change="change($event.item, $event.data)" :width="width" :height="height" :header="header")
</template>

<script>
	import Screen from './../../../mixins/screen'

	import MultiLevelDropdownMenu from './../../UI/MultiLevelDropdownMenu'

	export default {
		name: 'InputSelectDropdown',
		mixins: [Screen],
		screen: {
			updateOn: [],
			events: {
				"Show InputSelectDropdown": function(el, items, options) {

					this.items = items;
					this.width = options.width || 200;
					this.height = options.height || null;
					this.header = options.header || null;
					this.callback = options.callback;
					this.direction = options.direction || null;
					this.align = options.align || 'right';

					this.anchorRect = el.getBoundingClientRect();

					// Сначала открываем вниз, а после отрисовки меряем реальную высоту меню и при нехватке места разворачиваем вверх
					this.dropup = false;
					this.setPosition();

					this.update();

					this.$nextTick(() => this.adjustDirection());

				},
				// Клик в любом месте кроме контента помеченного input-select-dropdown - закрывает компонент
				"Pseudo Modal Process Hide": function(names) {

					if (!_.includes(names, 'input-select-dropdown') && this.showed) {

						this.close();

					}

				}
			}
		},
		components: {
			MultiLevelDropdownMenu
		},
		props: [],
		data() {

			this.items = [];
			this.callback = null;
			this.width = 200;
			this.height = null;
			this.header = null;
			this.direction = null;
			this.align = 'right';
			this.anchorRect = null;

			return {
				dropup: false,
				position: {
					left: 'auto',
					right: 0,
					bottom: 0
				}
			};

		},
		methods: {
			collectData() {

				if (this.$refs.dropdownMenu) this.$refs.dropdownMenu.setItems(this.items);

			},
			// Позиционируем контейнер относительно элемента-якоря:
			// по горизонтали: выравнивание по левому краю якоря (align: 'left') либо по правому краю (align: 'right')
			// по вертикали: при открытии вниз его нижняя граница совпадает с нижней границей якоря,
			// при открытии вверх - с верхней границей якоря (само меню при этом уходит вверх через bottom: 5px)
			setPosition() {

				if (!this.anchorRect) return;

				if (this.align === 'left') {

					this.position.left = this.anchorRect.left + this.width + 'px';
					this.position.right = 'auto';

				} else {

					this.position.left = 'auto';
					this.position.right = (document.body.clientWidth - this.anchorRect.right) + 'px';

				}

				this.position.bottom = (document.body.clientHeight - (this.dropup ? this.anchorRect.top : this.anchorRect.bottom)) + 'px';

			},
			// Определяем направление раскрытия: принудительно через options.direction ('up' / 'down') или автоматически если внизу не хватает места
			adjustDirection() {

				if (!this.showed || !this.anchorRect) return;

				let menuEl = this.$el.querySelector('.multi-level-dropdown-menu');
				let menuHeight = menuEl ? menuEl.offsetHeight : 0;

				let spaceBelow = window.innerHeight - this.anchorRect.bottom - 5;
				let spaceAbove = this.anchorRect.top - 5;

				if (this.direction === 'up') this.dropup = true;
				else if (this.direction === 'down') this.dropup = false;
				else this.dropup = menuHeight > spaceBelow && spaceAbove > spaceBelow;

				this.setPosition();

			},
			change(item, data) {

				this.callback(data);

				this.close();

			},
			close() {

				if (this.$refs.dropdownMenu) this.$refs.dropdownMenu.close();

				this.hide();

			}
		}
	}
</script>

<style lang="sass">

	.input-select-dropdown
		position: absolute
		margin-top: 1px
		user-select: none

		// Класс намеренно не называется dropup - в Bootstrap есть правило .dropup { position: relative } которое ломает позиционирование контейнера
		&.direction-up

			.multi-level-dropdown-menu.dropdown-menu
				top: auto
				bottom: 5px

</style>
